module.exports = __webpack_public_path__ + "static/media/wallfinishes_material_10y_y.281837ce.csv";